export const HOME = '/';
export const ABOUT_ME = '/about-me';
export const MY_WORK = '/my-work';
export const CV = '/cv';
